import VacationsAllowencesCountTable from './VacationsAllowencesCountTable';

export default VacationsAllowencesCountTable;
